<template>
  <div class="w-full h-full overflow-hidden" v-loading="loading">
    <template v-if="isSuccess">
      <dimension-setting-table
        :list="list"
        @confirm="initSettingList"
        v-if="list.length > 0"
      />
      <dimension-setting-field v-else />
    </template>
    <div v-else-if="isError" class="w-full h-full flex flex-col justify-center items-center">
      <p class="mb-3 text-medium text-theme-black-850 leading-22">
        初始化维度设置失败，请点击重试
      </p>
      <el-button type="primary" size="small" @click="initSettingList">重试</el-button>
    </div>
  </div>
</template>

<script>
import DimensionSettingField from './DimensionSettingField';
import DimensionSettingTable from './DimensionSettingTable';
import { getDimensionSettings } from '@/api/wenjuan/dimensionScore';

export default {
  name: 'DimensionSetting',
  components: {
    DimensionSettingField,
    DimensionSettingTable,
  },
  inject: {
    setFullActive: {
      default: () => () => {}
    },
    topSource: {
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      list: [],
      isError: false,
      isSuccess: false,
    }
  },
  mounted() {
    this.initSettingList();
  },
  methods: {
    initSettingList() {
      this.loading = true;
      getDimensionSettings().then((res) => {
        this.isSuccess = true;
        this.isError = false;
        const {
          openStandardScore,
          openWeight,
          computeMode,
          dimensions,
          showReportAfterAnswer,
          instruction
        } = res?.data?.data || {};
        this.list = dimensions || [];
        this.topSource.standardValue = !!openStandardScore;
        this.topSource.weightValue = !!openWeight;
        this.topSource.computeMode = computeMode ?? 0;
        this.topSource.showReportAfterAnswer = !!showReportAfterAnswer;
        try {
          const inst = JSON.parse(instruction ?? '{"instruction":""}');
          this.topSource.instruction = inst.instruction ?? '';
        } catch (e) {
          this.topSource.instruction = instruction ?? '';
        }
        if (this.list.length > 0) {
          this.setFullActive();
        } else {
          this.topSource.active = 0;
          this.topSource.currentView = 1;
        }
      }).catch(() => {
        this.isSuccess = false;
        this.isError = true;
      }).finally(() => {
        this.loading = false;
      });
    }
  }
}
</script>